import { render } from "./EventDetailPublicView.vue?vue&type=template&id=d2f40142&scoped=true"
import script from "./EventDetailPublicView.vue?vue&type=script&lang=js"
export * from "./EventDetailPublicView.vue?vue&type=script&lang=js"

import "./EventDetailPublicView.vue?vue&type=style&index=0&id=d2f40142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f40142"]])

export default __exports__